module.exports = __webpack_public_path__ + "img/4.a94d2f51.png";